import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isMobile, isTablet } from '../../utils/device';
import './Header.css';
import { featuredGames, categories } from '../../data/staticData';

const Header: React.FC = () => {
  const [deviceType, setDeviceType] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');

  const navigate = useNavigate();
  useEffect(() => {
    const detectDevice = () => {
      if (isMobile()) {
        setDeviceType('mobile');
      } else if (isTablet()) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    detectDevice();
    window.addEventListener('resize', detectDevice);

    return () => {
      window.removeEventListener('resize', detectDevice);
    };
  }, []);

  const handleRandomGame = async (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) e.currentTarget.blur();
    try {
      // const res = await fetch('/api/games/random');
      // if (!res.ok) throw new Error('No random game');
      // const randomGame = await res.json();

      var randInd = Math.floor(Math.random() * featuredGames.length);
      const randomGame = featuredGames[randInd];

      if (randomGame.urlkey) {
        navigate(`/game/${randomGame.urlkey}`);
        return;
      }
    } catch (e) {
      // fallback
      navigate(`/`);
    }
  };

  return (
    <header className={`header ${deviceType}`}>
        <div className="header-container">
          <Link to="/" className="logo">
            <img src="/images/logo.png" alt="randplays" style={{ height: '40px', width: 'auto' }} />
          </Link>
          <div className="random-button-container">
            <button onClick={e => handleRandomGame(e)}>
              <img src="/images/touzi.png" alt="Random" />
              <span>Random Game</span>
            </button>
          </div>
        </div>
      </header>
  );
};

export default Header; 